import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default ExpandMoreIcon;
